import React, { Component } from "react";
import NewUIOffer from "./offerV3";
import classnames from "classnames";
import goldlog from "@ali/goldlog";
import { sendWW, cplEnquiry, cplRecallRank, getLogin } from "../../../service";
import Util from "../../../pages/util/common";
import { Dialog, Slider, Button, Input, Feedback } from "@alife/next";
import _ from 'lodash';

const getExpParams = (exp) => {
  let res = {};
  let configs = exp.split(";");
  configs.map((configStr) => {
    let key = configStr.split(":")[0];
    let val = configStr.split(":")[1];
    res[key] = val;
  });
  return res;
};

class Offer extends Component {
  constructor(props) {
    super(props);
    this.wwClick = this.wwClick.bind(this);
    this.showLowPriceDialog = this.showLowPriceDialog.bind(this);
    this.state = {
      visible: false,
      dataList: [],
      phoneValue: "",
      msgValue: "",
      btnLoading: false,
      isLogin: false,
    };
  }
  componentDidMount() {
    const { data, idx } = this.props;
    const { imgUrl } = data;
    const { exp } = pageConfig;
    const expParams = getExpParams(exp || "");
    const saleListExp = expParams["qztf"] == "H";

    if (imgUrl.indexOf("cbu01.alicdn.com") > -1 && !/220x220/.test(imgUrl)) {
      data.imgUrl = `${imgUrl.replace(".jpg", ".220x220.jpg")}?_=2020`;
    }
    if (saleListExp && data.offerBangdan && data.offerBangdan.ranking <= 30) {
      goldlog.record(
        "/ifission.ifission.bangdan",
        "EXP",
        `keyword=${encodeURIComponent(window.pageConfig.keywords || "")}&idx=${idx}`,
        "GET"
      );
    }
  }
  wwClick() {
    const { data } = this.props;
    const isP4p = data.isP4p || data.isP4p ? 1 : 0;
    const { exp } = pageConfig;
    let expParams = getExpParams(exp || "");
    window.Light &&
      window.Light.setup({
        beforeOpenClient: (_targetElement, urlParamObj, next) => {
          urlParamObj.sourceValue = encodeURIComponent(
            JSON.stringify({
              sourceType: "pcOD",
              targetLoginId: data.loginId,
              source: "od",
              offerId: data.offerid,
              orderId: "",
              adClickId: Util.getUrlParam("clickid"),
              extra: {
                cosite: Util.getUrlParam("cosite"),
                pid: Util.getUrlParam("pid"),
                ptid: Util.getUrlParam("ptid"),
              },
            })
          );
          next(urlParamObj);
        },
      });
    if (
      Util.getCookie("__cn_logon_id__") &&
      isP4p &&
      expParams.pcSemWwClick === "B"
    ) {
      sendWW(data.eurl, data.offerId, "user_trigger");
    }
  }
  async showLowPriceDialog() {
    const { data, idx } = this.props;
    const isLogin = await getLogin();
    this.setState({ isLogin });
    const { cosite, ptid } = Util.getUrlParms();
    const arr = await cplRecallRank(data.offerId, data.offerBangdan.rankName, ptid, cosite);
    goldlog.record(
      "/ifission.ifission.bangdan",
      "CLK",
      `keyword=${encodeURIComponent(window.pageConfig.keywords || "")}&idx=${idx}`,
      "GET"
    );
    if (arr.code === "200") {
      let insertFlag = true;
      const newArr = arr.data.slice(0, 8).map((item) => {
        if (item.itemId === data.itemId) {
          item.eurl = data.eurl;
          insertFlag = false;
        }
        return item;
      });
      // 榜单内已有此商品就不手动插入品
      if (insertFlag) {
        if (newArr.length === 8) {
          newArr[7] = data;
        } else {
          newArr.push(data);
        }
      }
      this.setState({
        visible: true,
        dataList: newArr,
        phoneValue: "",
        msgValue: "",
      });
    } else {
      Feedback.toast.show({
        type: "prompt",
        content: arr.msg,
      });
    }
  }
  async dialogCommit() {
    const { phoneValue, msgValue, isLogin } = this.state;
    const { data } = this.props;
    if (!isLogin) {
      const phoneNumReg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (phoneValue.trim() === "") {
        Feedback.toast.show({
          type: "prompt",
          content: "电话号码不能为空",
        });
        return;
      } else if (!phoneNumReg.test(phoneValue)) {
        Feedback.toast.show({
          type: "prompt",
          content: "请填写正确的电话号码",
        });
        return;
      }
    }
    this.setState({ btnLoading: true });
    const res = await cplEnquiry({
      offerId: data.offerId,
      mobilePhone: phoneValue,
      nlq: msgValue,
      pushChannelType: isLogin ? "WANG_WANG" : "AD_FORM",
      items: this.state.dataList.map((item) => {
        const isAD = item.eurl && item.eurl.includes("dj.1688.com");
        return {
          eurl: item.eurl,
          itemType: isAD ? "AD" : "OFFER",
          itemId: item.itemId,
        };
      }),
      bizId: "lp_pc_rank"
    });
    this.setState({ btnLoading: false });
    if (res.code === "200") {
      this.setState({
        visible: false,
      });
    } else {
      Feedback.toast.show({
        type: "prompt",
        content: res.msg,
      });
    }
  }
  render() {
    const { data, index, buyerTags, idx } = this.props;
    const { phoneValue, msgValue, isLogin } = this.state;
    let cbu_ad_sessionid = "";
    let cbu_ad_adgroup_id = "";
    const isP4p = data.isP4p || data.isP4p ? 1 : 0;

    const style = {
      height: "322px",
      width: "222px",
      boxSizing: "border-box",
      position: "relative",
      marginRight: "11px",
      marginBottom: "20px",
    };

    data.isPcSem = true;
    // delete data.loginId
    //添加打点参数
    let { trackInfo } = data;
    if (trackInfo && typeof trackInfo === "string") {
      trackInfo = JSON.parse(trackInfo);
    } else if (!trackInfo) {
      trackInfo = {};
    }

    cbu_ad_sessionid = trackInfo.cbu_ad_sessionid;
    cbu_ad_adgroup_id = trackInfo.cbu_ad_adgroup_id;
    return (
      <div
        className={classnames({ offer_exp: data.impressionEurl })}
        data-jplus-exp-url={`${data.impressionEurl}&idx=${index}`}
        data-tracker="offer"
        data-aplus-report={`object_type@offer^object_id@${data.offerId}^_p_isad@${isP4p}^cbu_ad_sessionid@${cbu_ad_sessionid}^cbu_ad_adgroup_id@${cbu_ad_adgroup_id}`}
        style={style}
      >
        <NewUIOffer
          data={data}
          buyerTags={buyerTags}
          idx={idx}
          wwClick={this.wwClick}
          showLowPriceDialog={this.showLowPriceDialog}
        />
        <Dialog
          className="hot_sale_dialog"
          title="优选商家榜"
          visible={this.state.visible}
          footer={false}
          closeMode={["close", "esc"]}
          onClose={() => this.setState({ visible: false, btnLoading: false })}
        >
          <div>
            <Slider
              className="hot_sale_slider"
              infinite={false}
              slidesToShow={4}
              slidesToScroll={4}
              variableWidth
              arrowPosition="outer"
              dots={false}
            >
              {this.state.dataList.map((offer, idx) => {
                const priceNumArr = Util.formatNumber(offer.price, 2);
                return (
                  <a className="hot_sale_item" key={idx} href={offer.eurl ? offer.eurl : offer.odUrl} target="_blank">
                    <div className="hot_sale_img"><img src={offer.imgUrl} title={offer.company} alt={offer.company} className="main_img" /></div>
                    {idx < 4 ? (
                      <div className="hot_sale_title">
                        <div
                          className={`hot_sale_title_top hot_sale_title_top_${
                            idx + 1
                          }`}
                        >
                          Top{idx + 1}
                        </div>
                        <div className="hot_sale_title_company" title={offer.company}>
                          {offer.company}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {offer.price && <div className="hot_sale_num">
                      <span>￥</span>
                      <span className="large">{priceNumArr[0]}</span>
                      <span>.{priceNumArr[1]}</span>
                    </div>}
                  </a>
                );
              })}
            </Slider>
            {!isLogin ? (
              <div className="form-dialog-content">
                <div className="form-dialog-title">
                  您还可以选择留下联系方式，商家收到后会及时与您联系
                </div>
                <div className="form-dialog-phone">
                  <span>*</span>联系电话
                  <Input
                    value={phoneValue}
                    maxLength={13}
                    onChange={(value) => this.setState({ phoneValue: value })}
                    className="form-dialog-phone-input"
                    placeholder="请输入您的手机号码"
                  />
                  <div className="form-dialog-phone-tips">
                    <img src="https://img.alicdn.com/imgextra/i3/O1CN01poLOfN1rOTBvRvBLf_!!6000000005621-2-tps-28-28.png" />
                    隐私加密保护中，对商家隐藏真实号码
                  </div>
                </div>
                <div className="form-dialog-msg">
                  <div className="form-dialog-msg-div">
                    <span className="form-dialog-msg-title">需求信息</span>
                  </div>
                  <div>
                    <Input
                      value={msgValue}
                      onChange={(value) => this.setState({ msgValue: value })}
                      className="form-dialog-phone-msg"
                      placeholder="请简单描述你的需求"
                    />
                  </div>
                </div>
                <div className="form-dialog-agree">
                  点击比价按钮，表明您已阅读并同意
                  <a
                    href="https://terms.alicdn.com/legal-agreement/terms/c_end_product_protocol/20231031181421701/20231031181421701.html?spm=a261y.25179003.0.0.56883aa7cMyD2U"
                    target="_blank"
                  >
                    《用户协议》
                  </a>
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="hot_sale_footer">
              <Button
                loading={this.state.btnLoading}
                className="hot_sale_btn"
                onClick={() => this.dialogCommit()}
              >
                咨询比价
              </Button>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default Offer;
